export const reducirHash = ({hash, largo = 7}) => {

    if (!hash){
        return ''
    }

    return hash.substring(hash.length, hash.length - largo);

}